export default "__VITE_ASSET__6ebef3da__"